import { create } from "zustand";

interface StorageState {
    signedURLs: {
        [key: string]: {
            url: string,
            created: string,
            ttl: number
        }
    };
    setSignedURLs: (
        urls: {
            [key: string]: {
                url: string,
                created: string,
                ttl: number
            }
        }
    ) => void;
    removeExpiredURLs?: () => void;
}

const storageStore = create<StorageState>()((set) => ({
    signedURLs: {},
    setSignedURLs: (
        signedURLs: {
            [key: string]: {
                url: string,
                created: string,
                ttl: number
            }
        }
    ) => set({ signedURLs }),
    removeExpiredURLs: () => set((state) => {
        const now = Date.now();
        const signedURLs = Object.fromEntries(
            Object.entries(state.signedURLs).filter(([_, urlData]) => {
                const created = new Date(urlData.created).getTime();
                return created + urlData.ttl * 1000 > now;
            })
        );
        return { signedURLs };
    }),
}));

export default storageStore;